<p-dialog #dataParameters modal="true" styleClass="atlas-dialog-s" position="top" [closable]="false" [(visible)]="showDatePrompt">
  <ng-template pTemplate="header">
    {{ 'reports.saved-queries.date-parameters' | translate | titlecase }}
  </ng-template>
  <div *ngIf="currentQuery?.DateParameters != null">
    <div class="mct-grid mct-cols-1-1-1" *ngFor="let param of currentQuery.DateParameters">
      <div class="mct-flex mct-row mct-justify-center mct-items-center">{{ param.Name }}</div>
      <div class="mct-flex mct-row mct-justify-center mct-items-center">{{ param.Comparer }}</div>
      <div class="mct-flex mct-row mct-justify-center mct-items-end">
        <wl-date-selector [(ngModel)]="param.Value" appendTo="body"></wl-date-selector>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <wl-save-cancel-actions saveLabel="reports.saved-queries.use-selected" (onSave)="acceptDateParams()" (onCancel)="cancel()">
    </wl-save-cancel-actions>
  </ng-template>
</p-dialog>
